import React, { useState } from 'react';
import { isFunction } from 'lodash';
import { UnsavedChangesDialogProps } from './types';
import { UnsavedChangesDialogComponent } from './UnsavedChangesDialogComponent';
import { useNavigationBlocker } from './hooks';

export const UnsavedChangesDialog: React.FC<UnsavedChangesDialogProps> = ({
  onSave,
  when,
  isValid = true,
}) => {
  const [loading, setLoading] = useState(false);
  const { isBlocking, resetBlocking, proceedNavigation } = useNavigationBlocker(
    Boolean(when)
  );

  const onSubmit = async (action?: () => Promise<void>) => {
    setLoading(true);
    try {
      if (isFunction(action)) {
        await action();
      }
      proceedNavigation();
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <UnsavedChangesDialogComponent
      open={isBlocking}
      isValid={isValid}
      onSubmit={() => onSubmit(onSave)}
      disabled={loading}
      onClose={resetBlocking}
    />
  );
};
